import { Heading, Icon, Image, List, MediaObject, Paragraph } from '@zillow/constellation-10';
import { IconHammerFilled, IconHouseFilled, IconUserAddFilled } from '@zillow/constellation-icons';
import MagnifyingGlassUsers from '../../../../../images/magnifyingGlassUsers.svg';

export default function StepsToTakeToFindYourNextTenants() {
  return (
    <>
      <Image
        src={MagnifyingGlassUsers}
        alt="magnifying glass with 3 people in view"
        css={{ height: '160px', width: '160px', marginBottom: 'loose' }}
      />
      <Heading
        level={2}
        css={{
          textStyle:
            'responsive.heading-md' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
          marginBottom: 'looser',
          marginTop: 'tight',
        }}
      >
        Steps to take to find your next tenants
      </Heading>
      <List.Root appearance="none">
        <List.Item>
          <MediaObject
            media={
              <Icon size="lg" role="img">
                <IconUserAddFilled />
              </Icon>
            }
            css={{ marginBottom: 'looser' }}
          >
            <Heading
              level={3}
              css={{
                textStyle:
                  'responsive.body-lg-bold' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
              }}
            >
              Use Zillow’s rental applications
            </Heading>
            <Paragraph css={{ color: 'text.subtle' }}>
              It’s free for landlords and makes reviewing prospective tenants a breeze.
            </Paragraph>
          </MediaObject>
        </List.Item>
        <List.Item>
          <MediaObject
            media={
              <Icon size="lg" role="img">
                <IconHammerFilled />
              </Icon>
            }
            css={{ marginBottom: 'looser' }}
          >
            <Heading
              level={3}
              css={{
                textStyle:
                  'responsive.body-lg-bold' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
              }}
            >
              Manage any maintenance needs
            </Heading>
            <Paragraph css={{ color: 'text.subtle' }}>
              Use the time between tenants as an opportunity to address bigger repairs.
            </Paragraph>
          </MediaObject>
        </List.Item>
        <List.Item>
          <MediaObject
            media={
              <Icon size="lg" role="img">
                <IconHouseFilled />
              </Icon>
            }
            css={{ marginBottom: 'looser' }}
          >
            <Heading
              level={3}
              css={{
                textStyle:
                  'responsive.body-lg-bold' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
              }}
            >
              Update your listing
            </Heading>
            <Paragraph css={{ color: 'text.subtle' }}>
              Consider refreshing your photos and details to show off any improvements.
            </Paragraph>
          </MediaObject>
        </List.Item>
      </List.Root>
    </>
  );
}
